module.exports = __webpack_public_path__ + "static/media/loginpic2.cd57f43f.jpg";